import { render, staticRenderFns } from "./StateRulesLegend.vue?vue&type=template&id=08bfa8e4&scoped=true&"
import script from "./StateRulesLegend.vue?vue&type=script&lang=js&"
export * from "./StateRulesLegend.vue?vue&type=script&lang=js&"
import style0 from "./StateRulesLegend.vue?vue&type=style&index=0&id=08bfa8e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bfa8e4",
  null
  
)

export default component.exports